import {
    getIdToken,
    idTokenExpired,
    idTokenIsValid,
    isLoggedIn,
    refreshAuthenticationWithLock
} from "../Auth/AuthProvider";
const postWithoutAuth = async (url, body) => {
    return fetch(url, {
        method: "POST",
        headers: new Headers({
            "Content-Type": "application/json"
        }),
        body: body,
    });
}
const postWithAuth = async (url, body, options = {}) => {
    if (!body) {
        body = null;
    }

    const requestedHeaders = await headers(options);
    delete options.headers;
    return fetch(url, {
        method: "POST",
        headers: requestedHeaders,
        body: body,
        ...options,
    });
};
const postFileWithAuth = async (url, body, options = {}) => {

    if (!(body instanceof FormData)) {
        throw new Error("Body must be a FormData instance for multipart/form-data requests.");
    }

    return postWithAuth(url, body, options);
};

const getWithAuth = async (url, options = {}) => {
    return fetch(url, {
        method: "GET",
        headers: await headers(options),
    });

}

const patchWithAuth = async (url, body, options = {}) => {
    if (!body) {
        body = null;
    }

    const requestedHeaders = await headers(options);
    delete options.headers;
    return fetch(url, {
        method: "PATCH",
        headers: requestedHeaders,
        body: body,
        ...options,
    });
};

const headers = async (options = {}) => {
    if (isLoggedIn() && (!idTokenIsValid() || idTokenExpired())) {
        await refreshAuthenticationWithLock();
    }

    let myHeaders = {};
    if ("headers" in options) {
        myHeaders = {...(options.headers)};
    }

    const token = getIdToken();

    if (token) {
        myHeaders.Authorization = `Bearer ${token}`;
    }
    return myHeaders;
}

export { postWithoutAuth, postWithAuth, postFileWithAuth, getWithAuth, patchWithAuth };
